<template>    
    <v-dialog
      v-model="dialog"
      width="500"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Cobrar Factura
        </v-card-title>
        <v-layout wrap align-center>
            <v-flex xs8 offset-xs2>
                <v-select
                :items="items"
                label="Seleccione una opción"
                v-model="tipoCobro"                
                ></v-select>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="close"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogTipoCobro',
    data () {
      return {
        items: ['Efectivo','Cheque']
      }
    },
    methods:{
        close(){
            this.dialog = false;
            for (var i = 0; i < this.$store.state.documentNos.length; i++){
                this.cobraFactura(this.$store.state.documentNos[i]);                
            }            
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogTipoCobro;
            },
            set(value){
                this.$store.state.dialogTipoCobro = value;
            }
        },
        tipoCobro:{
            get(){
                return this.$store.state.tipoCobro;
            },
            set(value){
                this.$store.state.TipoCobro = value;
            }
        }
    }
}
</script>

